import '../../Pages/Client/AO/AODetails.scss';
import '../../Pages/Client/AO/Alertes.scss';

import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, createTheme,Dialog, IconButton, Toolbar } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
function DialogTransmettreCv({ openDialogTransmettreCv, setOpenDialogTransmettreCv}) {
    DialogTransmettreCv.propTypes = {
        openDialogTransmettreCv: PropTypes.any,
        setOpenDialogTransmettreCv: PropTypes.func,
    };
    const { i18n } = useTranslation();
    const {device}=useWindowSize();

    const handleCloseDialogTransmettreCv = () =>  {
        setOpenDialogTransmettreCv(false);
    };

    const scroll = 'paper';
    const theme = createTheme({
        overrides: {
            MuiAppBar: {
                root: {
                    borderRadius: '20px', // Set the desired borderRadius value here
                },
            },
        },
    });

    return (

        <Dialog
            fullScreen
            onClose={handleCloseDialogTransmettreCv}
            open={openDialogTransmettreCv}
            TransitionComponent={Transition}

            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <ThemeProvider theme={theme}>
                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseDialogTransmettreCv}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                {/*<Dialog
            onClose={handleCloseDialogTransmettreCv}
            open={openDialogTransmettreCv}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                    display: 'flex',
                    flexDirection:'column',
                    alignItems: 'center',
                    padding: '24px',
                },
            }}
        >*/}
                {/*<div className='frame00FicheCollab'>
                <div className='frame01FicheCollab'>
                    <IconButton onClick={handleCloseDialogTransmettreCv}>

                        <CloseIcon />
                    </IconButton>

                </div>
            </div>*/}

                <div className='AjouterDiplomeFrame121212'>
                    <h4 className='titlesociete'>{i18n.t('Transmettre des CVs')}</h4>
                    <div className='rechercheposte'>
                        <label className='recherchepostetxt'>{i18n.t('De')}</label>
                        <TextFieldComponent
                            required
                            variant="outlined"
                            style={{ width: '100%', background: 'white',borderRadius: '8px' }}
                        />

                    </div>
                    <div className='rechercheposte2'>
                        <label className='recherchepostetxt'>{i18n.t('À')}</label>
                        <TextFieldComponent
                            required
                            variant="outlined"
                            style={{ width: '100%', background: 'white',borderRadius: '8px' }}
                        />

                    </div>
                    <div className='rechercheposte2'>
                        <label className='recherchepostetxt'>{i18n.t('Sujet')}</label>
                        <TextFieldComponent
                            required
                            variant="outlined"
                            style={{ width: '100%',background: 'white',borderRadius: '8px' }}
                        />

                    </div>
                    <div className='rechercheposte2'>
                        <label className='recherchepostetxt'>{i18n.t('Message')}</label>
                        <textarea
                            name="#"
                            id="#"
                            cols="30"
                            rows="10"
                            className='textareatrasmettre'
                        ></textarea>

                    </div>
                    <div className='btnstransmettrecv'>
                        <Button
                            variant='text'
                            style={{
                                ...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}
                            }}
                            onClick={handleCloseDialogTransmettreCv}
                        >{i18n.t('Annuler')}</Button>
                        <Button
                            type='submit'
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                            // onClick={handleClick}
                            onClick={handleCloseDialogTransmettreCv}
                        >{i18n.t('Envoyer')}</Button>
                    </div>
                </div>
            </ThemeProvider>
        </Dialog>
    );
}

export default DialogTransmettreCv;
